<div class="cm-skeleton-form-field-preset">
  <!-- Label -->
  <div class="cm-skeleton cm-skeleton--text cm-skeleton--sm cm-skeleton--{{ animation() }}" style="width: 120px; margin-bottom: 0.5rem;"></div>
  <!-- Input field -->
  <div class="cm-skeleton cm-skeleton--rectangle cm-skeleton--{{ animation() }}" style="width: 100%; height: 48px; border-radius: 4px;"></div>
</div>
